import type { FilterSection } from "@/types/filter";
// import defaultBooleanOptions from "@/utils/constants/defaultBooleanOptions";
import legalFoundationCategoryFilterOptions from "@/utils/constants/legalFoundationCategoryFilterOptions";
import monthsFilterOption from "@/utils/constants/monthsFilterOption";
import yearsFilterOption from "@/utils/constants/yearsFilterOption";

const FILTER_SECTIONS: FilterSection[] = [
  {
    key: 'legalFoundationCategory',
    label: 'Legal Foundation Category',
    type: 'select',
    options: legalFoundationCategoryFilterOptions,
  },
  // {
  //   key: 'homePageKeyResources',
  //   label: 'Is Key Resource?',
  //   type: 'boolean',
  //   options: defaultBooleanOptions,
  // },
  {
    key: 'year',
    label: 'Year',
    type: 'select',
    options: yearsFilterOption,
  },
  {
    key: 'month',
    label: 'Month',
    type: 'select',
    options: monthsFilterOption,
  },
];

export default FILTER_SECTIONS;